<template>
  <div>
    <datatable
      title="Admin Skills"
      @thFilter="thFilter"
      @delete="deleteSkill"
      @create="createSkill"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
      :working_th_searches="working_th_searches"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-skills',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'skill_name',
          value: 'name'
        },
        {
          name: 'featured',
          value: 'featured'
        },
        {
          name: 'option_order_asc',
          value: 'option_order_asc'
        },
        {
          name: 'category',
          value: 'category'
        },
        {
          name: 'question_text',
          value: 'question_text'
        },
        {
          name: 'priority',
          value: 'priority'
        }
      ],
      th_filters: [],
      data: [],
      operations: [],
      chosen_text: {},
      working_th_searches: ['skill_name', 'category']
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllSkills({
        ...this.th_filters,
        sort: '-priority'
      }).then(response => {
        this.data = response
      })
    },
    deleteSkill (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteSkill',
        method_params: { id: delete_data.id }
      })
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      console.log(th_filters)
      this.init()
    },
    createSkill () {
      this.create({ designator: 'admin-skills-form-modal', component_name: 'AdminSkillsForm', is_create: true, modal_title: 'Create new Skill' })
    },
    editClick (data) {
      this.create({ designator: 'admin-skills-form-modal', component_name: 'AdminSkillsForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
